import { createApiInstance } from './helper/create-api-instance'

export const apiInstance = createApiInstance()
